import { useEffect, useState } from 'react';
import { useLayoutSettingsStore } from '@/stores/layoutSettingsStore';

export function useResolvedTheme() {
  const mode = useLayoutSettingsStore((state) => state.settings.themeMode ?? 'light');
  const [systemDark, setSystemDark] = useState(
    () => window.matchMedia('(prefers-color-scheme: dark)').matches,
  );
  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    setSystemDark(media.matches);
    const update = (event: MediaQueryListEvent) => setSystemDark(event.matches);
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  return mode === 'system' ? systemDark : mode === 'dark';
}
